import { HONG_KONG_SALES_ORG } from './constants';

/**
 * @name getHongKongOrTaiwanStateOptions
 * @desc Get the state dropdown options for HK and TW. Used by the Address Book and in Checkout
 * @param {String} salesOrg the sales org of the selected account
 */
const getHongKongOrTaiwanStateOptions = salesOrg => [
  { value: salesOrg === HONG_KONG_SALES_ORG ? 'HK' : 'TW', label: salesOrg === HONG_KONG_SALES_ORG ? 'HK' : 'TW' }
];

export default getHongKongOrTaiwanStateOptions;
